export const getDeployedTokenDataById = (selectedTokenId, deployedTokens, matchId, userId) => {
    // check if user have purchased tokens or not
    if (deployedTokens?.length === 0) return false;

    // Fetch the deployed token for the selectedTokenId
    const deployedToken = deployedTokens[selectedTokenId];

    if (!deployedToken || !deployedToken?.matchLeaderboardScore || deployedToken?.matchLeaderboardScore?.length === 0) {
      // If no deployed token or matchLeaderboardScore is empty, return false
      return false;
    }
    // Check if the matchId and userId in matchLeaderboardScore match the current matchId and userId
    const deployedEntry = deployedToken?.matchLeaderboardScore.find(
      (score) =>
        score?.matchId === matchId &&
        score?.userId === userId &&
        score?.isTokenDeployed === true
    );
    
    if (deployedEntry) {
      // If deployed, return true and set the deployedPlayerId and deployedActionName
      return {
        isDeployed: true,
        deployedPlayerId: deployedEntry.deployedPlayerId,
        deployedActionName: deployedEntry.deployedActionName,
        deployedTokenImage: deployedEntry.deployedTokenImage,
      };
    } else {
      return false;
    }
};

export const getDeployedActionAndPlayers = (actions, players, isDeployed) => {
    const deployedAction = actions.find((action) => action.actionName === isDeployed?.deployedActionName);
    const actionImage = {
      src: deployedAction?.actionImage,
      alt: deployedAction?.actionName,
      text: deployedAction?.actionName,
      id: deployedAction?._id, // for actions actionName is there id
    };

    const deployedPlayer = players.find((player) => player.playerId === isDeployed?.deployedPlayerId);
    const playerImage = {
        src: deployedPlayer?.profilePic,
        alt: deployedPlayer?.playerName,
        text: deployedPlayer?.playerName,
        id: deployedPlayer?.playerId
    };

    return { actionImage, playerImage };
}

export const updateCurrentTokenImages = ({ tokenIndex, actionImage, playerImage, tokens, setTokens }) => {
    const _tokens = [...tokens];
    const _token = _tokens.find((token) => token.tokenIndex === tokenIndex);

    if (_token) {
      _token.selectedImages = { actionImage, playerImage };
    } else {
      _tokens.push({
        tokenIndex,
        selectedImages: { actionImage, playerImage },
      });
    }

    setTokens(_tokens);
}

export const getFilteredPlayerAndActions = ({ players, actions }) => {
    const _players = players?.map(
        (player) => ({
            src: player?.profilePic,
            alt: player?.playerName,
            text: player?.playerName,
            id: player?.playerId,
        })
    );

    const _actions = actions?.map(
        (action) => ({
            src: action?.actionImage,
            alt: action?.actionName,
            text: action?.actionName,
            id: action?._id, // for actions actionName is there id
        })
    )

    return { players: _players || [], actions: _actions || [] };
}


export const getTokenDataById = (selectedTokenId, deployedTokens, matchId, userId, actions, players) => {
  // check if user have purchased tokens or not
  if (deployedTokens?.length === 0) return false;

  // Fetch the deployed token for the selectedTokenId
  const deployedToken = deployedTokens[selectedTokenId];

  const getFormattedTokenName = (token) =>
    token?.tokenName?.split('-')?.length > 0
      ? token.tokenName.split('-').at(-1) // Cleaner way to get the last part
      : "";

  const formattedTokenName = getFormattedTokenName(deployedToken);

  if (!deployedToken || !deployedToken?.matchLeaderboardScore || deployedToken?.matchLeaderboardScore?.length === 0) {
    // If no deployed token or matchLeaderboardScore is empty, return false
    return {
      isDeployed: false,
      tokenName: formattedTokenName,
      tokenZoneName: deployedToken?.zoneName || null,
    };
  }
  // Check if the matchId and userId in matchLeaderboardScore match the current matchId and userId
  const deployedEntry = deployedToken?.matchLeaderboardScore.find(
    (score) =>
      score?.matchId === matchId &&
      score?.userId === userId &&
      score?.isTokenDeployed === true
  );
  
  if (deployedEntry) {
    // If deployed, return true and set the deployedPlayerId and deployedActionName

    // mapping of player and actions is done with their id's to get their images
    const player = players?.find((p) => p.playerId === deployedEntry.deployedPlayerId); 
    const action = actions?.find((a) => a._id === deployedEntry.deployedActionId);

    return {
      isDeployed: true,
      playerName: deployedEntry?.deployedPlayerName,
      actionName: deployedEntry.deployedActionName,
      tokenName: formattedTokenName,
      tokenZoneName: deployedEntry.deployedTokenZoneName,
      playerImage: player?.profilePic || null, 
      actionImage: action?.actionImage || null, 
    };
  } return {
      isDeployed: false,
      tokenName: formattedTokenName,
      tokenZoneName: deployedToken.zoneName,
  };
};